import React, {FC} from 'react';
import {Typography} from "@mui/material";
import {sx} from "./sx";
import {useTranslation} from "react-i18next";
import NavigateIconStatus from "@view/navigate/icon/NavigateIconStatus";

interface IProps {
    label: string,
    isNewFeatures?: boolean,
    isOldFeatures?: boolean
}

const NavigateText: FC<IProps> = ({
                              label,
                              isNewFeatures,
                              isOldFeatures
}) => {

    const {t} = useTranslation()

    return (
        <Typography
            component={'div'}
            sx={sx.title}
        >
            {t(label)}
            {isOldFeatures && <NavigateIconStatus variant={'old'}/>}
            {isNewFeatures && <NavigateIconStatus variant={'new'}/>}
        </Typography>
    );
};

export default NavigateText;
